import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ordinal_suffix_of } from '../ReactGlobals';
import axios from 'axios';

const SessionAdd = props => {
    const { watch, handleSubmit, register, reset } = useForm();
    const [saving, setSaving] = useState(false);

    const submit = data => {
        if (saving) return;
        setSaving(true);

        var f = new FormData();
        Object.keys(data).forEach(k => f.append(k, data[k] ?? ""));

        (async () => {
            await axios.post(props.url, f, {withCredentials:true}).then(_ => {
                if (props.setModal) props.setModal(false);
                if (props.refreshTable) props.refreshTable();
                reset();
            }).catch(alert)
            setSaving(false);
        })();
    }

    return saving ? <>Saving data..</> :
        <form onSubmit={handleSubmit(submit)}>
            <div>
                <label>
                    <input {...register("isMultiple")} className="form-check-input" type="checkbox" /> Create Multiple?
                </label>
            </div>
            <hr />
            <div className="row my-2">
                <label class="col">
                    <input {...register("isSpecial")} className="form-check-input" type="checkbox" /> Special Session?
                </label>
            </div>
            <div className="row mb-2">
                {
                    watch('isMultiple') ? 
                        <div className="col-2">
                            From
                        </div> : ""
                }
                <div className="col-3"> 
                    <select {...register("num")} className="form-select">
                        {
                            new Array(350).fill("").map((_, i) => <option key={i }> {i + 1}</option>)
                        }
                    </select>
                </div>
                <div className="col">
                    <div className="form-control">
                        {ordinal_suffix_of(watch('num') ?? 2)} {watch('isSpecial') ? 'Special' : 'Regular'} Session
                    </div>
                </div>
            </div>
            {
                watch('isMultiple') ?
                <div className="row">
                    <div className="col-2">
                        To
                    </div> 
                    <div className="col-3">
                        <select {...register("numTo")} className="form-select">
                            {
                                new Array(350).fill("").map((_, i) => <option key={i}>{i + 1}</option>)
                            }
                        </select>
                    </div>
                        <div className="col">
                            <div className="form-control">
                                {ordinal_suffix_of(watch('numTo') ?? 2)} {watch('isSpecial') ? 'Special' : 'Regular'} Session
                            </div>
                        </div>
                </div> : ""
            }
            <hr style={{ marginLeft: -15, marginRight: -15 }} />
            <div style={{ margin: -15, padding: 5 }} className="d-flex justify-content-end">
                <button type="submit" className="ro-button">
                    <span>Save</span>
                </button>
            </div>
        </form>
}


export default SessionAdd